import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
  selector: 'app-order-cell-renderer',
  template: `
  <div class="order-cell-renderer" >
    <div class="row-layout" style="align-items:center;"><span>{{data.order_id}}</span>
    <div style="margin-left: 1rem" class="view-document-button">
      <button mat-icon-button (click)="onClick()">
        <mat-icon>visibility</mat-icon>
      </button>
    </div>
  </div>
    <div style="margin-top: 0.25rem;">{{data.status_name}}</div>
    <div *ngIf="data.order_deleted" class="is-deleted">gelöscht</div>
  </div>
`
})
export class OrderCellRendererComponent {

  data: any = {};

  constructor(private router: Router) { }

  // gets called once before the renderer is used
  agInit(params: ICellRendererParams): void {
    if (params.data) {
      this.data = params.data;
    }
  }

  refresh(params: ICellRendererParams) {
  }

  onClick() {
    const url = '/orders/' + this.data.order_id;
    this.data.order_id && this.router.navigate([url]);
  }
}
